import { Route } from '@angular/router';

export const environmentImports: Route[] = [
  {
    path: 'dev-tools',
    loadChildren: () => import('@safarilaw-webapp/feature/dev-tools').then(m => m.routes)
  }
];
